import { useState } from 'react';
import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import {
    Typography,
    Popover,
    FormControl,
    FormGroup,
    FormControlLabel,
    Checkbox
} from '@material-ui/core';
import {
    handleClickCheckedRoleOtherPrj,
    handleClickCheckedRolePublicRange,
    handleClickShowShareStatus,
    handleClosePopoverShareStatus
} from './../handler/ShareStatusKnowledgeHandler';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { corporationAtom } from '@/state/atom/corporationAtom';
import { Button } from '@material-ui/core';
import { handleBulkUpdateTicketAPI, handleMsgPendingWhenBulkActionInProcessing } from '../handler/ListTicketKnowledgeHandler';
import { useSnackbar } from 'notistack';
import { bulkActionKnowledgeTaskIdAtom } from '@/state/atom/ticketKnowledgeAtom';
import ItemPublicRange from './ItemPublicRange';
import localStorageUtil from '@/common/utils/localStorageUtil';
import trI18n from '@/common/utils/trI18n';
import { tr } from '@/common/utils/tr';
import { useTranslationSubscription } from '@/hooks/useTranslation';

function ListItemPublicRange(props) {
    // Re-render when the translation dictionary loads/updates
    useTranslationSubscription();

    const [openShareStatusPopover, setOpenShareStatusPopover] = useState('');
    const idPopoverShareStatus = openShareStatusPopover ? 'simple-popover' : undefined;
    const [shareStatusPopover, setShareStatusPopover] = useState(false);
    const corporationDetail = useRecoilValue(corporationAtom);
    let inviterLimitValue = corporationDetail.inviterSetting
    ? Utils.convertJSONDataToObject(corporationDetail.inviterSetting)
    : {};

    let isBasicView = props.selectPermission === Constant.LIST_PERMISSION_PUBLIC_RANGE.BASIC_VIEW;
    let isBasicEdit = props.selectPermission === Constant.LIST_PERMISSION_PUBLIC_RANGE.BASIC_EDIT;
    let isAddtionalView =
        props.selectPermission === Constant.LIST_PERMISSION_PUBLIC_RANGE.ADDITIONAL_VIEW;
    let isAddtionalEdit =
        props.selectPermission === Constant.LIST_PERMISSION_PUBLIC_RANGE.ADDITIONAL_EDIT;

    const { enqueueSnackbar } = useSnackbar();
    const setKnowledgeTaskId = useSetRecoilState(bulkActionKnowledgeTaskIdAtom);
    const [dataEditPublicRange, setDataEditPublicRange] = useState({
        status: false,
        action: Constant.BULK_ACTION.EDIT_PUBLIC_RANGE,
        params: {
            action: Constant.BULK_ACTION.EDIT_PUBLIC_RANGE
        }
    });

    let listDataDefault = localStorageUtil.getListDataPublicRangeDefault();
    const [isChangePublicRange, setIsChangePublicRange] = useState(false);

    const isCheckedBasicRoleOption = (permissionTitle, listPermission) => {
        if (listPermission.includes(Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION[permissionTitle])) {
            return true;
        }
        return false;
    };

    const isUsedBasicRoleOption = (role, listBasicCommon, listBasicOther) => {
        if (
            listBasicCommon.includes(Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION[role]) ||
            listBasicOther.includes(Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION[role])
        ) {
            return true;
        }
        return false;
    };

    const isCheckedAdditionRoleOption = (role, listDataRole) => {
        let hasRole = listDataRole.includes(role);
        return hasRole;
    };

    const isUsedAdditionRoleOption = (role, listDataRoleCommon, listDataRoleOther) => {
        let hasRole = listDataRoleCommon.includes(role) || listDataRoleOther.includes(role);
        return hasRole;
    };

    const handleSubmitEditRange = () => {
        // CALL API UPDATE
        props?.setIsShowEditRangeMulti(false)
        props.setListDataPublicRange(listDataDefault);
        setIsChangePublicRange(false);

        if (props.totalTickets > Constant.LIMIT_TICKET_UPDATE_MULTI) {
            props.setIsShowDialogNotiLimit(true)
            return;
        }

        document.body.style.cursor='wait';

        const updateData = { ...dataEditPublicRange }
        updateData.params.searchCondition = JSON.stringify(props.currentSearchParams)

        handleBulkUpdateTicketAPI(
            updateData, //isOpenDialogConfirm
            setDataEditPublicRange, //setIsOpenDialogConfirm
            setKnowledgeTaskId,
            false,
            enqueueSnackbar
        );

        props.setMsgInProcessingIcon(
            handleMsgPendingWhenBulkActionInProcessing(Constant.BULK_ACTION.EDIT_PUBLIC_RANGE)
        );
    };

    const renderListBasicView = () => {
        let listDataRoleProject = props.listDataPublicRange.listBasicViewCommon;
        let listDataRoleProjectOther = props.listDataPublicRange.listBasicViewOther;
        return (
            <FormControl component="fieldset" id={`form-control-share-status-all`}>
                <FormGroup
                    aria-label="position"
                    className={`share-status-range-li share-status-range-li-checked`}
                    id={`share-status-label-all-${Constant.KNOWLEDGE_TICKET_SHARE_STATUS.CREATOR_ONLY}-formGroup`}
                    row
                >
                    <FormControlLabel
                        value={Constant.KNOWLEDGE_TICKET_SHARE_STATUS.CREATOR_ONLY}
                        control={<Checkbox checked={true} disabled={true} color="secondary" />}
                        label={tr(Constant.KNOWLEDGE_TICKET_SHARE_STATUS.CREATOR_ONLY)}
                        labelPlacement={'end'}
                        id={`share-status-label-all-${Constant.KNOWLEDGE_TICKET_SHARE_STATUS.CREATOR_ONLY}`}
                    />
                </FormGroup>
                <FormGroup
                    aria-label="position"
                    className={`share-status-range-li share-status-range-li-checked`}
                    id={`share-status-label-all-${Constant.KNOWLEDGE_TICKET_SHARE_STATUS.IN_PROJECT}-formGroup`}
                    row
                >
                    <FormControlLabel
                        value={Constant.KNOWLEDGE_TICKET_SHARE_STATUS.IN_PROJECT}
                        control={<Checkbox checked={true} disabled={true} color="secondary" />}
                        label={tr(Constant.KNOWLEDGE_TICKET_SHARE_STATUS.IN_PROJECT)}
                        labelPlacement={'end'}
                        id={`share-status-label-all-${Constant.KNOWLEDGE_TICKET_SHARE_STATUS.IN_PROJECT}`}
                    />
                </FormGroup>

                <ItemPublicRange
                    roleId={Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.IN_ORG}
                    roleName={tr(Constant.KNOWLEDGE_TICKET_SHARE_STATUS.IN_ORG)}
                    selectPermission={props.selectPermission}
                    listDataCommon={listDataRoleProject}
                    dataEditPublicRange={dataEditPublicRange}
                    listDataRoleProject={listDataRoleProject}
                    listDataRoleProjectOther={listDataRoleProjectOther}
                    groupRole={Constant.LIST_GROUP_ROLE_PUBLIC_RANGE.BASIC_VIEW}
                    setDataEditPublicRange={setDataEditPublicRange}
                    isUseRoleOption={isUsedBasicRoleOption}
                    isCheckRoleOption={isCheckedBasicRoleOption}
                    handleClickCheckedRolePublicRange={handleClickCheckedRolePublicRange}
                    setIsChangePublicRange={setIsChangePublicRange}
                />
                {(corporationDetail.deskService === Constant.STATUS_SERVICE_PERMISSION.ON || inviterLimitValue.deskService === Constant.STATUS_SERVICE_PERMISSION.ON) && (
                    <>
                        <ItemPublicRange
                            roleId={Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.B2B_CUSTOMER}
                            roleName={tr(Constant.KNOWLEDGE_TICKET_SHARE_STATUS.B2B_CUSTOMER)}
                            selectPermission={props.selectPermission}
                            listDataCommon={listDataRoleProject}
                            dataEditPublicRange={dataEditPublicRange}
                            listDataRoleProject={listDataRoleProject}
                            listDataRoleProjectOther={listDataRoleProjectOther}
                            groupRole={Constant.LIST_GROUP_ROLE_PUBLIC_RANGE.BASIC_VIEW}
                            setDataEditPublicRange={setDataEditPublicRange}
                            isUseRoleOption={isUsedBasicRoleOption}
                            isCheckRoleOption={isCheckedBasicRoleOption}
                            handleClickCheckedRolePublicRange={handleClickCheckedRolePublicRange}
                            setIsChangePublicRange={setIsChangePublicRange}

                        />
                        <ItemPublicRange
                            roleId={Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.B2B_SUPPORT}
                            roleName={tr(Constant.KNOWLEDGE_TICKET_SHARE_STATUS.B2B_SUPPORT)}
                            selectPermission={props.selectPermission}
                            listDataCommon={listDataRoleProject}
                            dataEditPublicRange={dataEditPublicRange}
                            listDataRoleProject={listDataRoleProject}
                            listDataRoleProjectOther={listDataRoleProjectOther}
                            groupRole={Constant.LIST_GROUP_ROLE_PUBLIC_RANGE.BASIC_VIEW}
                            setDataEditPublicRange={setDataEditPublicRange}
                            isUseRoleOption={isUsedBasicRoleOption}
                            isCheckRoleOption={isCheckedBasicRoleOption}
                            handleClickCheckedRolePublicRange={handleClickCheckedRolePublicRange}
                            setIsChangePublicRange={setIsChangePublicRange}
                        />
                        <ItemPublicRange
                            roleId={Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.PUBLIC}
                            roleName={tr(Constant.KNOWLEDGE_TICKET_SHARE_STATUS.PUBLIC)}
                            selectPermission={props.selectPermission}
                            listDataCommon={listDataRoleProject}
                            dataEditPublicRange={dataEditPublicRange}
                            listDataRoleProject={listDataRoleProject}
                            listDataRoleProjectOther={listDataRoleProjectOther}
                            groupRole={Constant.LIST_GROUP_ROLE_PUBLIC_RANGE.BASIC_VIEW}
                            setDataEditPublicRange={setDataEditPublicRange}
                            isUseRoleOption={isUsedBasicRoleOption}
                            isCheckRoleOption={isCheckedBasicRoleOption}
                            handleClickCheckedRolePublicRange={handleClickCheckedRolePublicRange}
                            setIsChangePublicRange={setIsChangePublicRange}
                        />
                    </>
                )}
            </FormControl>
        );
    };

    const renderListBasicEdit = () => {
        let listDataRoleProject = props?.listDataPublicRange.listBasicEditCommon;
        let listDataRoleProjectOther = props?.listDataPublicRange.listBasicEditOther;
        return (
            <FormControl component="fieldset" id={`form-control-share-status-all`}>
                <FormGroup
                    aria-label="position"
                    className={`share-status-range-li share-status-range-li-checked`}
                    id={`share-status-label-all-${Constant.KNOWLEDGE_TICKET_SHARE_STATUS.CREATOR_ONLY}-formGroup`}
                    row
                >
                    <FormControlLabel
                        value={Constant.KNOWLEDGE_TICKET_SHARE_STATUS.CREATOR_ONLY}
                        control={<Checkbox checked={true} disabled={true} color="secondary" />}
                        label={tr(Constant.KNOWLEDGE_TICKET_SHARE_STATUS.CREATOR_ONLY)}
                        labelPlacement={'end'}
                        id={`share-status-label-all-${Constant.KNOWLEDGE_TICKET_SHARE_STATUS.CREATOR_ONLY}`}
                    />
                </FormGroup>
                <FormGroup
                    aria-label="position"
                    className={`share-status-range-li share-status-range-li-checked`}
                    id={`share-status-label-all-${Constant.KNOWLEDGE_TICKET_EDIT_PERMISSION_TEXT.PROJECT_MANAGER}-formGroup`}
                    row
                >
                    <FormControlLabel
                        value={Constant.KNOWLEDGE_TICKET_EDIT_PERMISSION_TEXT.PROJECT_MANAGER}
                        control={<Checkbox checked={true} disabled={true} color="secondary" />}
                        label={tr(Constant.KNOWLEDGE_TICKET_EDIT_PERMISSION_TEXT.PROJECT_MANAGER)}
                        labelPlacement={'end'}
                        id={`share-status-label-all-${Constant.KNOWLEDGE_TICKET_EDIT_PERMISSION_TEXT.PROJECT_MANAGER}`}
                    />
                </FormGroup>

                <ItemPublicRange
                    roleId={Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.IN_PROJECT}
                    roleName={tr(Constant.KNOWLEDGE_TICKET_SHARE_STATUS.IN_PROJECT)}
                    selectPermission={props.selectPermission}
                    listDataCommon={listDataRoleProject}
                    dataEditPublicRange={dataEditPublicRange}
                    listDataRoleProject={listDataRoleProject}
                    listDataRoleProjectOther={listDataRoleProjectOther}
                    groupRole={Constant.LIST_GROUP_ROLE_PUBLIC_RANGE.BASIC_EDIT}
                    setDataEditPublicRange={setDataEditPublicRange}
                    isUseRoleOption={isUsedBasicRoleOption}
                    isCheckRoleOption={isCheckedBasicRoleOption}
                    handleClickCheckedRolePublicRange={handleClickCheckedRolePublicRange}
                    setIsChangePublicRange={setIsChangePublicRange}
                />
                <ItemPublicRange
                    roleId={Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.IN_ORG}
                    roleName={tr(Constant.KNOWLEDGE_TICKET_SHARE_STATUS.IN_ORG)}
                    selectPermission={props.selectPermission}
                    listDataCommon={listDataRoleProject}
                    dataEditPublicRange={dataEditPublicRange}
                    listDataRoleProject={listDataRoleProject}
                    listDataRoleProjectOther={listDataRoleProjectOther}
                    groupRole={Constant.LIST_GROUP_ROLE_PUBLIC_RANGE.BASIC_EDIT}
                    setDataEditPublicRange={setDataEditPublicRange}
                    isUseRoleOption={isUsedBasicRoleOption}
                    isCheckRoleOption={isCheckedBasicRoleOption}
                    handleClickCheckedRolePublicRange={handleClickCheckedRolePublicRange}
                    setIsChangePublicRange={setIsChangePublicRange}
                />
                {(corporationDetail.deskService === Constant.STATUS_SERVICE_PERMISSION.ON || inviterLimitValue.deskService === Constant.STATUS_SERVICE_PERMISSION.ON) && (
                    <>
                        <ItemPublicRange
                            roleId={Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.B2B_CUSTOMER}
                            roleName={tr(Constant.KNOWLEDGE_TICKET_SHARE_STATUS.B2B_CUSTOMER)}
                            selectPermission={props.selectPermission}
                            listDataCommon={listDataRoleProject}
                            dataEditPublicRange={dataEditPublicRange}
                            listDataRoleProject={listDataRoleProject}
                            listDataRoleProjectOther={listDataRoleProjectOther}
                            groupRole={Constant.LIST_GROUP_ROLE_PUBLIC_RANGE.BASIC_EDIT}
                            setDataEditPublicRange={setDataEditPublicRange}
                            isUseRoleOption={isUsedBasicRoleOption}
                            isCheckRoleOption={isCheckedBasicRoleOption}
                            handleClickCheckedRolePublicRange={handleClickCheckedRolePublicRange}
                            setIsChangePublicRange={setIsChangePublicRange}
                        />
                        <ItemPublicRange
                            roleId={Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.B2B_SUPPORT}
                            roleName={tr(Constant.KNOWLEDGE_TICKET_SHARE_STATUS.B2B_SUPPORT)}
                            selectPermission={props.selectPermission}
                            listDataCommon={listDataRoleProject}
                            dataEditPublicRange={dataEditPublicRange}
                            listDataRoleProject={listDataRoleProject}
                            listDataRoleProjectOther={listDataRoleProjectOther}
                            groupRole={Constant.LIST_GROUP_ROLE_PUBLIC_RANGE.BASIC_EDIT}
                            setDataEditPublicRange={setDataEditPublicRange}
                            isUseRoleOption={isUsedBasicRoleOption}
                            isCheckRoleOption={isCheckedBasicRoleOption}
                            handleClickCheckedRolePublicRange={handleClickCheckedRolePublicRange}
                            setIsChangePublicRange={setIsChangePublicRange}
                        />
                        <ItemPublicRange
                            roleId={Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.PUBLIC}
                            roleName={tr(Constant.KNOWLEDGE_TICKET_EDIT_PERMISSION_TEXT.PUBLIC)}
                            selectPermission={props.selectPermission}
                            listDataCommon={listDataRoleProject}
                            dataEditPublicRange={dataEditPublicRange}
                            listDataRoleProject={listDataRoleProject}
                            listDataRoleProjectOther={listDataRoleProjectOther}
                            groupRole={Constant.LIST_GROUP_ROLE_PUBLIC_RANGE.BASIC_EDIT}
                            setDataEditPublicRange={setDataEditPublicRange}
                            isUseRoleOption={isUsedBasicRoleOption}
                            isCheckRoleOption={isCheckedBasicRoleOption}
                            handleClickCheckedRolePublicRange={handleClickCheckedRolePublicRange}
                            setIsChangePublicRange={setIsChangePublicRange}
                        />
                    </>
                )}
            </FormControl>
        );
    };

    const getListDataAdditionPermission = () => {
        let listDataRoleProject = props?.listDataPublicRange.listAdditionalViewCommon;
        let listDataRoleProjectOther = props?.listDataPublicRange.listAdditionalViewOther;
        if (!isAddtionalView) {
            listDataRoleProject = props?.listDataPublicRange.listAdditionalEditCommon;
            listDataRoleProjectOther = props?.listDataPublicRange.listAdditionalEditOther;
        }
        return {
            listDataRoleProject, 
            listDataRoleProjectOther
        }
    }

    const renderListAdditionPermission = () => {
        let listDataAdditionPermission = getListDataAdditionPermission();
        let listDataCommon = listDataAdditionPermission.listDataRoleProject;
        let listDataOther = listDataAdditionPermission.listDataRoleProjectOther;

        let listDataOrgProject = listDataCommon?.orgProject;
        let listDataB2bCustomerProject = listDataCommon?.b2bCustomerProject;
        let listDataB2bHelpdeskProject = listDataCommon?.b2bHelpdeskProject;
        let guestCustomerProject = listDataCommon?.guestCustomerProject || [];
        let baseProjectList = listDataCommon?.baseProject || [];
        let listDataOthersProject = [
            ...guestCustomerProject,
            ...baseProjectList
        ];

        let listDataOrgProjectOther = listDataOther.orgProject;
        let listDataB2bCustomerProjectOther = listDataOther.b2bCustomerProject;
        let listDataB2bHelpdeskProjectOther = listDataOther.b2bHelpdeskProject;

        let listAdditionalRole = props.listAdditionalAllRole;
        let listPrjInOrg = listAdditionalRole.listPrjInOrg;
        let listB2BCustomerPrj = listAdditionalRole.listB2BCustomerPrj;
        let listB2BHelpdeskPrj = listAdditionalRole.listB2BHelpdeskPrj;
        let listOrthers = listAdditionalRole.listOrthers;
        let baseProject = listAdditionalRole.baseProject;

        let customInitListPrjIdOther = [];
        for (let key in listDataOther) {
            if (Array.isArray(listDataOther[key])) {
                customInitListPrjIdOther = customInitListPrjIdOther.concat(listDataOther[key]);
            }
        }

        return (
            <FormControl component="fieldset" id={`form-control-share-status-all`}>
                <div className="label-list-permission">{trI18n('LABEL_PRJ_IN_ORG')}</div>
                {listPrjInOrg.map(role => {
                    return (
                        <ItemPublicRange
                            key={role.id}
                            roleId={role.id}
                            roleName={role.name}
                            selectPermission={props.selectPermission}
                            listDataCommon={listDataCommon}
                            dataEditPublicRange={dataEditPublicRange}
                            listDataRoleProject={listDataOrgProject}
                            listDataRoleProjectOther={listDataOrgProjectOther}
                            groupRole={Constant.LIST_GROUP_ROLE_PUBLIC_RANGE.PRJ_IN_ORG}
                            setDataEditPublicRange={setDataEditPublicRange}
                            isUseRoleOption={isUsedAdditionRoleOption}
                            isCheckRoleOption={isCheckedAdditionRoleOption}
                            handleClickCheckedRolePublicRange={handleClickCheckedRolePublicRange}
                            setIsChangePublicRange={setIsChangePublicRange}
                        />
                    );
                })}
                {!Utils.isEmptyArray(listB2BCustomerPrj) && (
                    <>
                        <div className="label-list-permission mg-10">
                            {trI18n('LABEL_B2B_CUSTOMER_PRJ')}
                        </div>
                        {listB2BCustomerPrj.map(role => {
                            return (
                                <ItemPublicRange
                                    key={role.id}
                                    roleId={role.id}
                                    roleName={role.name}
                                    selectPermission={props.selectPermission}
                                    listDataCommon={listDataCommon}
                                    dataEditPublicRange={dataEditPublicRange}
                                    listDataRoleProject={listDataB2bCustomerProject}
                                    listDataRoleProjectOther={listDataB2bCustomerProjectOther}
                                    groupRole={Constant.LIST_GROUP_ROLE_PUBLIC_RANGE.B2B_CUSTOMER}
                                    setDataEditPublicRange={setDataEditPublicRange}
                                    isUseRoleOption={isUsedAdditionRoleOption}
                                    isCheckRoleOption={isCheckedAdditionRoleOption}
                                    handleClickCheckedRolePublicRange={
                                        handleClickCheckedRolePublicRange
                                    }
                                    setIsChangePublicRange={setIsChangePublicRange}
                                />
                            );
                        })}
                    </>
                )}

                {!Utils.isEmptyArray(listB2BHelpdeskPrj) && (
                    <>
                        <div className="label-list-permission mg-10">
                            {trI18n('LABEL_B2B_HELPDESK_PRJ')}
                        </div>
                        {listB2BHelpdeskPrj.map(role => {
                            return (
                                <ItemPublicRange
                                    key={role.id}
                                    roleId={role.id}
                                    roleName={role.name}
                                    selectPermission={props.selectPermission}
                                    listDataCommon={listDataCommon}
                                    dataEditPublicRange={dataEditPublicRange}
                                    listDataRoleProject={listDataB2bHelpdeskProject}
                                    listDataRoleProjectOther={listDataB2bHelpdeskProjectOther}
                                    groupRole={Constant.LIST_GROUP_ROLE_PUBLIC_RANGE.B2B_SUPPORT}
                                    setDataEditPublicRange={setDataEditPublicRange}
                                    isUseRoleOption={isUsedAdditionRoleOption}
                                    isCheckRoleOption={isCheckedAdditionRoleOption}
                                    handleClickCheckedRolePublicRange={
                                        handleClickCheckedRolePublicRange
                                    }
                                    setIsChangePublicRange={setIsChangePublicRange}
                                />
                            );
                        })}
                    </>
                )}
                {(corporationDetail.deskService === Constant.STATUS_SERVICE_PERMISSION.ON || inviterLimitValue.deskService === Constant.STATUS_SERVICE_PERMISSION.ON) && (
                    <>
                        <div className="label-list-permission mg-10">
                            {trI18n('LABEL_ORTHERS_PRJ')}
                        </div>
                        {listOrthers.map(role => {
                            return (
                                <ItemPublicRange
                                    key={role.id}
                                    roleId={role.id}
                                    roleName={tr(role.name)}
                                    selectPermission={props.selectPermission}
                                    listDataCommon={listDataCommon}
                                    dataEditPublicRange={dataEditPublicRange}
                                    listDataRoleProject={listDataOthersProject}
                                    listDataRoleProjectOther={customInitListPrjIdOther}
                                    baseProject={baseProject}
                                    setDataEditPublicRange={setDataEditPublicRange}
                                    isUseRoleOption={isUsedAdditionRoleOption}
                                    isCheckRoleOption={isCheckedAdditionRoleOption}
                                    handleClickCheckedRoleOtherPrj={handleClickCheckedRoleOtherPrj}
                                    setIsChangePublicRange={setIsChangePublicRange}
                                />
                            );
                        })}
                    </>
                )}
            </FormControl>
        );
    };

    return (
        <div className="icon-edit-public-range">
            <Typography
                className="icon-edit-public-range"
                aria-describedby={idPopoverShareStatus}
                variant="contained"
                onClick={e =>
                    handleClickShowShareStatus(
                        e,
                        props?.setIsShowListPublicRange,
                        setShareStatusPopover,
                        setOpenShareStatusPopover
                    )
                }
            >
                {' '}
                <img src="/assets/image/edit-setting-public-url.svg" alt="icon-edit-range" />
            </Typography>
            <Popover
                className="share-status-popover"
                id={idPopoverShareStatus}
                key={`popover-share-status-all`}
                open={openShareStatusPopover}
                anchorEl={shareStatusPopover}
                onClose={e =>
                    handleClosePopoverShareStatus(
                        setShareStatusPopover,
                        setOpenShareStatusPopover,
                        props?.setIsShowListPublicRange,
                        props.setListDataPublicRange,
                        setIsChangePublicRange
                    )
                }
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right'
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right'
                }}
                PaperProps={{
                    style: {
                        marginTop: '12px',
                        marginLeft: '7px',
                        borderRadius: '8px'
                    }
                }}
            >
                <div>
                    <div
                        className="knowledge-share-public-status-list"
                        id={`share_status_id_all_public_range`}
                    >
                        <div className="list-permission-status">
                            {isBasicView && renderListBasicView()}
                            {isBasicEdit && renderListBasicEdit()}
                            {(isAddtionalView || isAddtionalEdit) &&
                                renderListAdditionPermission()}
                        </div>
                        <div
                            className="share-status-popover-additional"
                        >
                            <Button
                                className="btn-send btn-primary btn-hg32"
                                variant="contained"
                                color="primary"
                                onClick={e => handleSubmitEditRange(e)}
                                disabled={!isChangePublicRange}
                            >
                                {trI18n('COMBTN003')}
                            </Button>
                        </div>
                    </div>
                </div>
            </Popover>
        </div>
    );
}

export default ListItemPublicRange;
